export default function Go_Arrays () {
  return (
    <div>
      <h1>Go_Arrays </h1>
      <p>Go Arrays</p>
    </div>
  );
}